export const QR_CART_ITEMS_KEY = "cart_items";
export const QR_MENU_PRODUCT_IDS_KEY = "qr_menu_product_ids";

const safeJsonParse = (value, fallback) => {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch (error) {
    return fallback;
  }
};

export const getQrContextKey = ({ src, table, isDriveThru }) =>
  [src, table, isDriveThru]
    .map((value) => (value === undefined || value === null ? "" : String(value)))
    .join("|");

export const getStoredQrContextKey = () =>
  getQrContextKey({
    src: localStorage.getItem("src"),
    table: localStorage.getItem("table"),
    isDriveThru: localStorage.getItem("is_drive_thru"),
  });

export const clearQrCart = () => {
  localStorage.removeItem(QR_CART_ITEMS_KEY);
};

export const readQrCartItems = () => {
  const cartItems = safeJsonParse(localStorage.getItem(QR_CART_ITEMS_KEY), []);
  return Array.isArray(cartItems) ? cartItems : [];
};

export const saveQrCartItems = (items) => {
  localStorage.setItem(QR_CART_ITEMS_KEY, JSON.stringify(items || []));
};

export const getQrMenuProductIds = (categoriesProducts) => {
  const productIds = [];

  (categoriesProducts || []).forEach((category) => {
    (category.products || []).forEach((product) => {
      const isAvailable =
        !product?.is_stockable || Number(product?.stock || 0) > 0;

      if (isAvailable && product?.id !== undefined && product?.id !== null) {
        productIds.push(String(product.id));
      }
    });
  });

  return productIds;
};

export const saveQrMenuProductIds = (productIds) => {
  localStorage.setItem(
    QR_MENU_PRODUCT_IDS_KEY,
    JSON.stringify((productIds || []).map(String)),
  );
};

export const readQrMenuProductIds = () => {
  const productIds = safeJsonParse(
    localStorage.getItem(QR_MENU_PRODUCT_IDS_KEY),
    [],
  );

  return Array.isArray(productIds) ? productIds.map(String) : [];
};

export const hasCartItemMissingFromMenu = (cartItems, productIds) => {
  if (!Array.isArray(cartItems) || cartItems.length === 0) {
    return false;
  }

  if (!Array.isArray(productIds) || productIds.length === 0) {
    return true;
  }

  const menuProductIds = new Set(productIds.map(String));

  return cartItems.some(
    (item) => !menuProductIds.has(String(item?.id ?? item?.product_id)),
  );
};

export const clearCartIfMenuChanged = (productIds) => {
  const cartItems = readQrCartItems();

  if (hasCartItemMissingFromMenu(cartItems, productIds)) {
    clearQrCart();
    return true;
  }

  return false;
};
